import { useState, useCallback } from "react";
import Header from "../components/landing/Header";
import HeroLeadMontaz from "../components/landing/HeroLeadMontaz";
import TrustStrip from "../components/landing/TrustStrip";
import ComparisonSection from "../components/landing/ComparisonSection";
import HowItWorksMontaz from "../components/landing/HowItWorksMontaz";
import QuickQuizCTAMontaz from "../components/landing/QuickQuizCTAMontaz";
import MicroProofMontaz from "../components/landing/MicroProofMontaz";
import FAQMontaz from "../components/landing/FAQMontaz";
import FinalCTAShort from "../components/landing/FinalCTAShort";
import Footer from "../components/landing/Footer";
import QuizDialog from "../components/landing/QuizDialog";
import MobileStickyCTA from "../components/landing/MobileStickyCTA";
import { PageProvider } from "../config/PageContext";

export default function MontazPage() {
  const [quizOpen, setQuizOpen] = useState(false);
  const openQuiz = useCallback(() => setQuizOpen(true), []);

  return (
    <PageProvider value="MONTAZ">
      <div
        className="min-h-screen bg-white text-brand-ink font-body overflow-x-hidden"
        data-testid="montaz-page"
      >
        <Header ctaLabel="Zostaw numer" />
        <main>
          <HeroLeadMontaz />
          <TrustStrip />
          <ComparisonSection />
          <HowItWorksMontaz />
          <QuickQuizCTAMontaz onQuizClick={openQuiz} />
          <MicroProofMontaz />
          <FAQMontaz />
          <FinalCTAShort />
        </main>
        <Footer />
        <QuizDialog open={quizOpen} onOpenChange={setQuizOpen} />
        <MobileStickyCTA label="Zostaw numer" />
      </div>
    </PageProvider>
  );
}
